import { render, staticRenderFns } from "./escalatorSettings.vue?vue&type=template&id=63124aff"
import script from "./escalatorSettings.vue?vue&type=script&lang=js"
export * from "./escalatorSettings.vue?vue&type=script&lang=js"
import style0 from "./escalatorSettings.vue?vue&type=style&index=0&id=63124aff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports